import React, { Component } from 'react';
import { getCookie } from '../../../utils/CookieHelper';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import Service from '../../../config/networkutils';
import { Avatar, Box, CircularProgress, TextField, Button } from '@material-ui/core';
import { getPrimaryColor } from '../../Helper/CommonThings';
import { withStyles } from '@material-ui/styles';

const token = getCookie("ptd_ts_token");

const useStyles = (theme) => ({
    small: {
        width: theme.spacing(3.5),
        height: theme.spacing(3.5),
        backgroundColor: getPrimaryColor(),
        color: '#fff'
    },
});

class CommentSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comments: [],
            newComment: '',
            isLoading: true,
            btnDisabled: false
        };
    }

    componentDidMount() {
        this.fetchComments();
    }

    handleTextChange(e) {
        this.setState({ newComment: e.target.value });
    }

    fetchComments = () => {
        this.setState({ isLoading: true });
        Service.get(`/api/employee/comments/get_employee_comments/?emp_id=${this.props.empData.id}`, {
            headers: {
                Authorization: 'Token ' + token,
            },
        })
            .then(response => {
                this.setState({ comments: response.data, isLoading: false });
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
            });
    }

    addComments() {
        if (this.state.newComment.trim() === '') {
            this.props.enqueueSnackbar("Comment cannot be empty", { variant: "warning" });
            return;
        }
        this.setState({ btnDisabled: true });
        Service.post('/api/employee/comments/create_employee_comments/', {
            headers: {
                Authorization: 'Token ' + token,
            },
            data: {
                comment: this.state.newComment,
                emp_id: this.props.empData.id
            },
        })
            .then((res) => {
                this.props.enqueueSnackbar('Added successfully.', {
                    variant: 'success'
                });
                this.setState({ btnDisabled: false, newComment: '' }, () => {
                    this.fetchComments();
                })
                if (this.props.updateComment) {
                    this.props.updateComment(res.data);
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ btnDisabled: false });
                this.props.enqueueSnackbar('something went wrong!', {
                    variant: 'error'
                });
            });
    }

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Box display='flex' flexDirection='row' style={{ width: '100%' }}>
                    <Box display='flex' flexDirection='column' style={{ width: '100%' }} >

                        <Box style={{ width: '100%' }} justifyContent='center'>
                            <TextField
                                id="comments"
                                label="Type a comment..."
                                multiline
                                rows={2}
                                variant="outlined"
                                style={{ width: '100%' }}
                                value={this.state.newComment}
                                onChange={(e) => this.handleTextChange(e)}
                            />
                        </Box>
                        <Box display='flex' width={'100%'} flexDirection="row-reverse" marginRight={'10px'} marginTop={'10px'}>
                            <Button size="small" variant="contained" disabled={this.state.btnDisabled} color={'primary'} onClick={() => this.addComments()}>{this.state.btnDisabled ? <CircularProgress size={24} /> : 'Add Comments'}</Button>
                        </Box>
                        {this.state.isLoading ?
                            <Box display='flex' justifyContent='center' marginTop='10px'>
                                <CircularProgress />
                            </Box>
                            :
                            this.state.comments.length !== 0 ?
                                <div>
                                    <Box fontWeight={'bold'} fontSize={14}>
                                        All Comments
                                    </Box>
                                    <Box style={{ width: '100%', maxHeight: '400px', overflowY: 'auto' }}>
                                        {this.state.comments.map((value, i) => (
                                            <Box key={i} marginTop='10px' marginBottom={'5px'} display={'flex'} flexDirection='column'>
                                                <Box display={'flex'} flexDirection='row' alignItems={'center'}>
                                                    <Box display={'flex'} flexDirection='row' flexGrow={1} alignItems={'center'}>
                                                        <Box>
                                                            <Avatar className={classes.small}><Box fontWeight={'bold'} fontSize={'9px'} >{value.created_by__first_name.charAt(0) + value.created_by__last_name.charAt(0)}</Box></Avatar>
                                                        </Box>
                                                        <Box marginLeft="10px" fontWeight={'bold'}>{value.created_by__first_name + " " + value.created_by__last_name}</Box>
                                                    </Box>
                                                    <Box>{moment(value.date_created).format(' DD MMM YYYY, h:mm a')}</Box>
                                                </Box>
                                                <Box marginLeft='37px'>
                                                    {value.comment}
                                                </Box>
                                            </Box>
                                        ))}</Box>
                                </div> : <Box display='flex' justifyContent='center' marginTop='10px'>No Comments.</Box>
                        }
                    </Box>
                </Box>

            </div >
        );
    }
}

export default withStyles(useStyles)(withSnackbar(CommentSection));